import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { SiteAnnouncementModule } from '../shared/components/site-announcement/site-announcement.module';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    SiteAnnouncementModule,
  ],
  declarations: [LayoutComponent],
  providers: [],
})
export class LayoutModule {
}
